import { incidentReportsConstants } from 'locale/incidentReports'
import { FollowUpActionStatus } from '@lmc/ts-common'

export const getStatusLabel = (status: string, t: (key: string) => string) => {
  return (
    t(
      incidentReportsConstants[status as keyof typeof incidentReportsConstants],
    ) || status
  )
}

export const getStatusOptions = (t: (key: string) => string) => [
  {
    value: FollowUpActionStatus.notStarted,
    label: getStatusLabel(FollowUpActionStatus.notStarted, t),
  },
  {
    value: FollowUpActionStatus.pending,
    label: getStatusLabel(FollowUpActionStatus.pending, t),
  },
  {
    value: FollowUpActionStatus.completed,
    label: getStatusLabel(FollowUpActionStatus.completed, t),
  },
  {
    value: FollowUpActionStatus.skipped,
    label: getStatusLabel(FollowUpActionStatus.skipped, t),
  },
]
